import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./Store/index";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import { ThemeProvider } from "./Context/Theme";
import { AuthProvider } from "./Context/Auth";
import Amplify from "@aws-amplify/core";
import awsconfig from "./aws-exports";
import { RouteProvider } from "./Context/RouteContext";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0,
});
Amplify.configure(awsconfig);

ReactDOM.render(
  <Router>
    <Provider store={store}>
      <ThemeProvider>
        <AuthProvider>
          <RouteProvider>
            <App />
          </RouteProvider>
        </AuthProvider>
      </ThemeProvider>
    </Provider>
  </Router>,
  document.getElementById("root")
);
reportWebVitals();
